import Pay from './pay';

export default Pay;
